/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useMemo } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { Link } from "react-router";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import { useForm } from "@/src/provider/Form/FormProvider";
import _isEmpty from "lodash/isEmpty";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import formSubmitStyle from "./formSubmitStyle";
import { Box } from "@mui/material";
import { sxToArray } from "@/src/services/utils";

export default function FormSubmit({
  hideBackButton = false,
  disabled,
  isLoading = false,
  nextText = "Weiter",
  nextButtonSubtext,
  backText = "Zurück",
  backLink = "/",
  onBackClick,
  sx,
}: FormSubmitProps) {
  const { errors }: any = useForm();
  const isValid = useMemo(() => {
    return _isEmpty(errors);
  }, [errors]);
  return (
    <Grid
      container
      sx={[{
        width: "100%",
        justifyContent: "center",
        alignItems: "baseline"
      }, formSubmitStyle.applicationActions, ...sxToArray(sx)]}>
      {!isValid && (
        <Grid sx={formSubmitStyle.invalidContainer} size={12}>
          <Grid container sx={{
            justifyContent: "flex-end"
          }}>
            <Grid
              role="alert"
              sx={formSubmitStyle.invalidText}
              size={{
                xs: 12,
                sm: 6
              }}>
              Leider sind Ihre Angaben noch nicht richtig oder vollständig. Bitte prüfen Sie Ihre Angaben oben.
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid
        sx={formSubmitStyle.backButtonContainer}
        size={{
          xs: 12,
          sm: 6
        }}>
        {!hideBackButton && (
          <Button fullWidth variant={"text"} component={Link} sx={formSubmitStyle.backButton} onClick={onBackClick} to={backLink}>
            {backText}
          </Button>
        )}
      </Grid>
      <Grid
        sx={formSubmitStyle.submitButtonContainer}
        size={{
          xs: 12,
          sm: 6
        }}>
        <ButtonLoading fullWidth variant={"contained"} color={"primary"} type={"submit"} disabled={disabled} isLoading={isLoading}>
          {nextText}
        </ButtonLoading>
        {!!nextButtonSubtext && <Box sx={formSubmitStyle.buttonSubtext}>{nextButtonSubtext}</Box>}
      </Grid>
    </Grid>
  );
}
